<template>
  <el-dialog
    title="編輯外部頻道"
    :visible.sync="innerVisible"
    v-loading="isLoading"
  >
    <el-form :model="form" ref="form" :rules="rules">
      <!--<el-form-item label="所屬單位" :label-width="formLabelWidth">-->
      <!--<el-input :value="myownOrg" readonly autocomplete="off"></el-input>-->
      <!--</el-form-item>-->

      <el-form-item label="頻道名稱" :label-width="formLabelWidth" prop="name">
        <el-input v-model="form.name" autocomplete="off"></el-input>
      </el-form-item>

      <el-form-item
        label="外部頻道名稱"
        :label-width="formLabelWidth"
        prop="parentName"
      >
        <el-input :value="parentName" readonly autocomplete="off"></el-input>
      </el-form-item>

      <el-form-item :label-width="formLabelWidth">
        <el-switch
          v-model="form.isPublic"
          active-text="公開"
          inactive-text="非公開"
        ></el-switch>
      </el-form-item>

      <!--<el-form-item :label-width="formLabelWidth" label="">-->
        <!--<el-switch-->
          <!--v-model="form.enableAssign"-->
          <!--active-text="啟用 頻道管理員個人授權功能"-->
          <!--inactive-text="關閉" ></el-switch>-->
      <!--</el-form-item>-->

      <el-form-item label="顏色" :label-width="formLabelWidth" prop="color">
        <div style="width:480px;marginBottom:-20px">
          <el-radio-group v-model="form.color">
            <el-radio
              v-for="itemColor in extTagColorList"
              :key="itemColor.name"
              :label="itemColor.name"
            >
              <span :style="{ color: itemColor.textColor }">
                {{ itemColor.txtLabel }}
              </span>
            </el-radio>
          </el-radio-group>
        </div>
      </el-form-item>
    </el-form>
    <template #footer class="dialog-footer">
      <el-button @click="innerVisible = false">取 消</el-button>
      <el-button type="primary" @click="submit">確 定</el-button>
    </template>
  </el-dialog>
</template>

<script>
import { mapGetters } from "vuex";
import tagColorsMixin from "@/components/mixin/tagColors.js";
import API from "@/api/";
export default {
  mixins: [tagColorsMixin],
  model: {
    prop: "visible",
    event: "toggleVisible",
  },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    selectedItemId: {
      type: Number,
      default: null,
    },
  },
  computed: {
    ...mapGetters({
      myownOrg: "auth/orgName",
    }),
    innerVisible: {
      get() {
        return this.visible;
      },
      set(val) {
        this.$emit("toggleVisible", val);
      },
    },
  },
  data() {
    return {
      rules: {
        name: [{ required: true, message: "請輸入頻道名稱", trigger: "blur" }],
        color: [{ required: true, message: "請輸入顏色", trigger: "blur" }],
      },
      formLabelWidth: "100px",
      isLoading: false,
      parentName: "",
      form: {
        name: "",
        isPublic: true,
        color: "primary",
        enableAssign: false,
      },
    };
  },
  created() {
    //console.log(`dlg created: chnl id = ${this.selectedItemId}`);
    if (this.innerVisible) {
      if (this.selectedItemId !== null) {
        this.isLoading = true;
        API.channel
          .get(this.selectedItemId)
          .then(res => {
            this.form.id = res.data.id;
            this.form.name = res.data.name;
            this.form.no = res.data.no;
            this.form.isPublic = res.data.isPublic;
            this.form.color = res.data.color;
            this.form.enableAssign = res.data.enableAssign;
            this.isLoading = false;
            this.parentName = res.data.parent.name;
          })
          .catch(err => {
            this.isLoading = false;
            this.$alert(`資料取得發生錯誤：${err}`, "系統錯誤", {
              confirmButtonText: "確定",
              callback: () => {
                this.innerVisible = false;
              },
            });
          });
      }
    }
  },
  methods: {
    submit() {
      this.$refs["form"].validate(valid => {
        if (valid) {
          this.submitUpdate();
        } else {
          return false;
        }
      });
    },
    submitAdd() {
      //console.log(
      //`submitAdd: adminIds = ${JSON.stringify(this.form.adminIds)}`
      //);
      this.$store.dispatch("channel/add", this.form).then(() => {
        this.innerVisible = false;
        this.$store.dispatch("channel/list", null);
      });
    },
    submitUpdate() {
      this.$store
        .dispatch("channel/update", this.form)
        .then(() => {
          this.innerVisible = false;
        })
        .finally(() => {
          const max = this.$store.getters["channel/max"];
          const offset = this.$store.getters["channel/offset"];
          const sort = this.$store.getters["channel/sort"];
          const order = this.$store.getters["channel/order"];
          this.$store.dispatch("channel/list", {
            scope: "external",
            max,
            offset,
            sort,
            order,
          });
        });
    },
  },
};
</script>

<style></style>
